import { ResponseData } from "src/app/@types/interfaces/get.response";
import { CoreService } from "./core.service";
import youthRegistrationsData from "src/app/data/total-youth-registrations-by-program.json";
import hostRegistrationsData from "src/app/data/total-host-registrations-by-program.json";

interface JsonResponse<T> {
  registrations: T[];
}

export default class ReportService extends CoreService {
  async getTotalYouthRegistrationsByProgram(): Promise<
    ResponseData<JsonResponse<any>>
  > {
    return Promise.resolve({
      success: true,
      message: "Youth registrations report loaded",
      data: {
        registrations: youthRegistrationsData.totalYouthRegistrationsByProgram,
      },
    });
  }

  async getTotalHostRegistrationsByProgram(): Promise<
    ResponseData<JsonResponse<any>>
  > {
    return Promise.resolve({
      success: true,
      message: "Host registrations report loaded",
      data: {
        registrations: hostRegistrationsData.totalHostRegistrationsByProgram,
      },
    });
  }
}

export const reportService = new ReportService();
